const notificationTypes = {
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  FETCH_NOTIFICATIONS_START: 'FETCH_NOTIFICATIONS_START',
  FETCH_NOTIFICATIONS_SUCCESS: 'FETCH_NOTIFICATIONS_SUCCESS',
  FETCH_NOTIFICATIONS_FAILURE: 'FETCH_NOTIFICATIONS_FAILURE',
  MARK_NOTIFICATION_AS_READ: 'MARK_NOTIFICATION_AS_READ',
  MARK_NOTIFICATIONS_SEEN: 'MARK_NOTIFICATIONS_SEEN',
  UPDATE_NOTIFICATION_COUNTS: 'UPDATE_NOTIFICATION_COUNTS',
  CLEAR_NOTIFICATIONS: 'CLEAR_NOTIFICATIONS',
};

export default notificationTypes;
